import { createContext, useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";

const context = createContext(false);

export function PrintContext(props: React.PropsWithChildren) {
  const [isPrinting, setIsPrinting] = useState(false);
  const onChange = (e: MediaQueryListEvent) => {
    if (e.matches) return flushSync(() => setIsPrinting(true));
    setIsPrinting(false);
  };
  useEffect(() => {
    const m = window.matchMedia("print");
    m.addEventListener("change", onChange);
    return () => {
      m.removeEventListener("change", onChange);
    };
  }, []);
  return (
    <context.Provider value={isPrinting}>{props.children}</context.Provider>
  );
}

export function useIsPrinting() {
  return useContext(context);
}
